<div class="login-container">
  <div class="login-card fade-in">

      <div *ngIf="!errorMessage && isLoading && !showEmailPrompt" class="logging-in-message">
         Logging into portal...
      </div>

      <div *ngIf="showEmailPrompt" class="email-prompt-container">
        <h2>Enter Email Address</h2>
        <p class="email-prompt-sub">Please enter your email to complete sign in and registration.</p>
        
        <form (ngSubmit)="submitEmail()" #emailForm="ngForm">
          <div class="input-group">
            <input type="email" name="email" [(ngModel)]="emailInput" placeholder="name@example.com" required email class="form-input">
          </div>
          <button type="submit" [disabled]="!emailForm.form.valid" class="submit-btn">
            Save & Continue
          </button>
        </form>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <div class="footer">
       &copy; 2024 KCEG. All Rights Reserved.
     </div>
  </div>
</div>